export function getBonusPercentLevel(schedule: [number, number][], groupPV: number): number {
  const bonus = schedule.find(([min]) => groupPV >= min) ?? [0, 0.00]
  return bonus[1]
}
